import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
import {  useHistory } from "react-router-dom";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaTokenExt} from "../funciones/ClienteAxios";
import axios from 'axios';
import moment from 'moment';
export default function MapaLeafComuna({lista, }) {
  const mapRef = useRef()
  //const params = useParams()
  let history = useHistory();
  const source = axios.CancelToken.source();
  const [cargando, setCargando] = useState(true)
  const [centro, setCentro] = useState([-17.3936218,-66.2336069])
  const [listPoligono, setListPoligono] = useState([])
  const hoy=moment(new Date()).format('YYYY-MM-DD')      

  useEffect(()=>{         
    
   // getListPoligono(1, "1", 9, municipioId)
    //getListMarcador(1, "1", 9, municipioId)
    //console.log(lista);
    
   mapRef.current =  leaflet.map('map').setView([-17.39642560364779,-66.15880049066588], 11.45);
    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    
    if (lista.length!==0 && lista.distrito.length!==0  ) {
      const nvoList =lista.distrito
      const centro =[nvoList[9].DtLat, nvoList[9].DtLon]
      mapRef.current.setView(centro,11.4);
      let arrPoligono=[],arrPoligono2=[] ,arrPoligono3=[]
      nvoList.forEach((poligono)=>{

        let arrPath=[]
       
        if (poligono.gps) {
          poligono.gps.forEach((paths)=>{
          
            arrPath.push([paths.Lt,paths.Ln])
          })
        }
        let nvoarr=[]
        nvoarr.push(arrPath)
        // console.log(arrPoligono3 ,poligono);
        if (arrPoligono3.length===0) {          
          
          arrPoligono3.push({color:poligono.DtCol, arregloPol:nvoarr})
        }
        else{          
          const filtro = arrPoligono3.filter((elemento)=>elemento.color===poligono.DtCol) 
          if (filtro.length===0) {
            arrPoligono3.push({color:poligono.DtCol, arregloPol:nvoarr})  
          }
          else{
            const filtro2 = arrPoligono3.filter((elemento)=>elemento.color!==poligono.DtCol) 
            if (filtro2.length===0) {
              arrPoligono3.push({color:poligono.DtCol, arregloPol:nvoarr})  
            }
            else{
            let aux1=[]
            let auxFiltro=filtro[0].arregloPol
            //console.log(filtro[0].arregloPol);
            
            auxFiltro.push(nvoarr)
           // console.log(auxFiltro);
            
            arrPoligono3.push(...filtro2,{color:poligono.DtCol, arregloPol:auxFiltro})  
            }
          }
          
        }         
           //arrPoligono2.push(arrPath)
          
        
        const greenIcon = nvoIconLeaflet('/marker-icon-2x-green.png', poligono.DtId) 
        let marker = leaflet.marker([poligono.DtLat,poligono.DtLon], {icon:greenIcon});    
        const cadena=`${poligono.DtNom}`          
        marker.bindPopup(cadena).openPopup();
        marker.addTo(mapRef.current).on('click', mostrar);
      })
     
       arrPoligono3.forEach((poligono)=>{
        nvoPoligono(poligono.arregloPol, poligono.color)   
      })  
      
      //nvoPoligono(arrPoligono2, "#F08652")   
      /* const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.5, fillColor: ['#9a8fcd', ]});
      polygon.addTo(mapRef.current); 
      const polygon2 = leaflet.polygon(arrPoligono2, { fillOpacity: 0.5, fillColor: [ "#F08650" ]});
      polygon2.addTo(mapRef.current);  */
    }
    
    return () => {
      mapRef.current = null
      source.cancel();
    }

  },[]) 

  const nvoPoligono=(arrPoligono, color)=>{
    const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.8, fillColor: color});
    polygon.addTo(mapRef.current); 
  }

/*   useEffect(()=>{         
    
    if (listaPromovid && listaPromovid.lenght!== 0 ) {
      listaPromovid.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        { let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })
          }      
          const promoIcon = nvoIconLeaflet('/marker-icon-2x-green.png')
          let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:promoIcon});    
          const cadena=`${poligono.Nom}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);  
        }        
      })         
    }          
    
  },[listaPromovid, ])  */

  const nvoIconLeaflet=(iconUrl,auxID, iconAncho, )=>{
    const nvo=new leaflet.Icon({
      id:auxID,
      iconUrl: iconUrl,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [iconAncho??25, 41],
      iconAnchor: [iconAncho??12, 41],
      popupAnchor: [1, -34],
      shadowSize: [iconAncho??41, 41]
    });
    return nvo
  }

  const mostrar=(e)=>{
    
    
   // console.log(e.target.options.icon.options.id,filtro);       
  
  }
 
  return (  
    <div id="map" ref={mapRef} style={{height:"100%" }}/>  
  );
}